<template>
  <div>
    <v-card outlined style='border-radius: 5px'>
      
      <v-card-title primary-title class='content-border-title'>
        <span>Informações</span>
        <v-spacer></v-spacer>
        <v-btn 
          color="black" text small dense class="mr-3 title-financial btn-primary"  
          v-if="$route.name =='EditMember'" 
          @click="enable_fields = !enable_fields"
        ><v-icon left>mdi-pencil</v-icon> Habilitar edição</v-btn>
        
        <v-btn 
          color="black" text small dense class="mr-3 title-financial btn-primary"
          @click="$router.push({name: 'MyCompanyMemberList'})"
        ><v-icon>mdi-close</v-icon></v-btn>

      </v-card-title>
      <v-divider></v-divider>
      <card-loading-transparent v-if="loading && loading_roles"/>
      <v-card-text v-if="!loading && !loading_roles" class="pt-4">

        <v-form ref="editUserRoleForm" :disabled="!enable_fields">
          <v-text-field
            v-model="user.name"
            prepend-icon="mdi-account-outline"
            label="Nome"
            :rules="nameRules"
            readonly
            dense
            outlined
          ></v-text-field>
          <v-select
            dense
            outlined
            multiple
            attach
            chips
            small-chips
            prepend-icon="mdi-account-tie-outline"
            :items="roles"
            v-model="user.my_roles"
            label="Cargos"
            :rules="required_selected"
            :menu-props="{ bottom: true, offsetY: true }"
          ></v-select>

        </v-form>
        
      </v-card-text>
      <v-card-actions class="justify-center pb-5">
        <v-btn 
          color="black" text small dense class="mr-3 title-financial btn-success"
          v-if="$route.name =='EditMember'" :disabled="!enable_fields" @click="saveMember"
        >
          <v-icon left>mdi-content-save</v-icon> Atualizar 
        </v-btn>
        <v-btn 
          color="black" text small dense class="mr-3 title-financial btn-error"
          v-if="$route.name =='EditMember'" :disabled="!enable_fields" @click="$router.push({name: 'MyCompanyMemberList'})"
        >
          <v-icon  left>mdi-cancel</v-icon> Cancelar 
        </v-btn>
      </v-card-actions>
    </v-card>
    <dialog-loading v-if="saving" :loading="saving" loadingText="Salvando"></dialog-loading>
  </div>
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'
  import validations from '@/mixins/validations';
  import Api from '@/api'
  export default {
    name: 'EditMemberRole',
    mixins: [
      validations
    ],
    data: () => ({
      loading: false,
      loading_roles: false,
      user: {
        name: '',
        //email: '',
        //phone: '',
        my_roles: [],
      },
      roles: [],
      enable_fields: false,
      saving: false,
      aux_roles: [],
    }),
    methods: {
      getData(){
        if(this.$route.params.id){
          this.getUserInfo(this.$route.params.id)
        }
      },
      getUserInfo(id){
        this.loading = true
        Api.User.show(id).then(r => r.data).then(d => {
          if (d.my_roles.filter(r=> r.resource_id == this.activeCompanyId).length == 0){
            this.$router.go(-1)
            this.addNotification({msg: 'Desculpe, esse usuário não pertence mais a essa empresa', type: 'error'})
          } else {

            let user_roles = d.my_roles.filter( el => el.resource_id == this.activeCompanyId )
            this.aux_roles = d.my_roles.filter( el => el.resource_id != this.activeCompanyId )

            this.user = {
              id: d.id,
              name: d.name,
              my_roles: user_roles
            }
          }
          // this.user.role_ids = d.role && d.role.id || null
        }).finally(()=> {
          this.loading = false
        })
      },
      setRoles(){
        this.loading_roles = true;
        Api.Role.indexWithFilter({company_id: this.activeCompanyId}).then(r=>r.data).then(d=> {
          this.roles = d.map((obj)=>(
            {
              text: obj.translated,
              value: obj
            }
          ))
        }).catch((err) => {
          this.addNotification({type: 'error', msg: `Erro: ${err}`})
        }).finally(() => {
          this.loading_roles = false 
        })
      },
      saveMember(){
        if (this.$refs.editUserRoleForm.validate()) {
           this.$swal({
            showConfirmButton: true,
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            title: `Deseja realizar alteração?`,
            icon: 'question',
          }).then((r)=> {
            if (r.isConfirmed) {
              this.updateUserRole()
            };
          })
        };
      },
      updateUserRole(){
        this.saving = true;

        let user_infos = this.prepareUserRoles()

        Api.User.update(user_infos).then(() => {
          this.addNotification({type: 'success', msg: 'Realizado com sucesso'})
        }).catch((err) =>{
          this.addNotification({type: 'error', msg: `Erro: ${err}`})
        }).finally(() => {
          this.$router.push({name: 'MyCompanyMemberList', params: {any_member_updated: true}})
          this.saving = false;
        })
      },
      prepareUserRoles(){

        let user_updated = {id: this.user.id, role_ids: []}
  
        this.user.my_roles.map(obj => user_updated.role_ids.push(obj.id))
        this.aux_roles.map(obj=> user_updated.role_ids.push(obj.id))

        return user_updated
      },
      ...mapActions({
        addNotification: 'Notification/add'
      })
    },
    computed: {
      ...mapState({
        activeCompanyId: state => state.App.activeCompanyId
      }),
    },
    mounted () {
      this.setRoles()
      this.getData()
    },
    watch: {
      activeCompanyId(nv){
        if(nv){
          this.$router.push({name: 'MyCompanyMemberList'})
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>